import React, { useState } from "react";
import { getFirestore, doc, deleteDoc } from "firebase/firestore";
import Swal from "sweetalert2";
import DetallesView from "./DetallesView";
import FacturasView from "./FacturasView";
import GastosView from "./GastosView";
import HistorialView from "./HistorialView";

export default function PreviaPedidos({
  orden,
  numeroOrden,
  clientes = [],
  cerrarPrevia,
  onEditar,
  balance = 0,
  ingresos = 0,
  gastosTotales = 0,
  gastosPorCategoria = [],
  ultimasTransacciones = [],
}) {
  const [activeTab, setActiveTab] = useState("detalles");

  const handleDelete = async () => {
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción eliminará la orden.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      scrollbarPadding: false,
    });
    if (result.isConfirmed) {
      const db = getFirestore();
      await deleteDoc(doc(db, "pedidos", orden.id));
      Swal.fire({
        title: "Eliminado",
        text: "La orden ha sido eliminada.",
        icon: "success",
        confirmButtonColor: "#d33",
        scrollbarPadding: false,
      }).then(() => window.location.reload());
    }
  };

  return (
    <div className="container-gastos">
      <div className="modal-close" onClick={cerrarPrevia}>
        <i className="bi bi-x-lg" />
      </div>

      <div className="cotizacion-header">
        <div className="header-text">
          <h2 className="header-title-gastos">Orden de Compra</h2>
          <h3 className="header-subtitle-gastos">
            #{String(numeroOrden).padStart(4, "0")}
          </h3>
        </div>

        <div className="order-tabs">
          {[
            { key: "detalles", icon: "card-list", label: "Detalles" },
            { key: "facturas", icon: "receipt", label: "Facturas" },
            { key: "gastos", icon: "cash-stack", label: "Gastos" },
            { key: "historial", icon: "clock-history", label: "Historial" },
          ].map(({ key, icon, label }) => (
            <button
              key={key}
              className={`tab-button ${activeTab === key ? "active" : ""}`}
              onClick={() => setActiveTab(key)}
            >
              <i className={`bi bi-${icon}`} />
              <span style={{ marginLeft: 5 }}>{label}</span>
            </button>
          ))}
        </div>

        <div className="actions-group">
          <div className="action-icon" onClick={() => onEditar(orden)}>
            <i className="bi bi-pencil-fill" />
          </div>
          <div className="action-icon" onClick={() => window.print()}>
            <i className="bi bi-printer-fill" />
          </div>
          <div className="action-icon" onClick={handleDelete}>
            <i className="bi bi-trash" />
          </div>
        </div>
      </div>

      {activeTab === "detalles" && (
        <DetallesView
          fechaOrden={orden.fechaOrden}
          clienteId={orden.cliente}
          clientes={clientes}
          usuario={orden.usuario}
          productos={orden.productosSeleccionados}
          descuento={orden.descuento}
        />
      )}

      {activeTab === "facturas" && <FacturasView />}

      {activeTab === "gastos" && (
        <GastosView
          ordenId={orden.id}
          balance={balance}
          ingresos={ingresos}
          gastosTotales={gastosTotales}
          gastosPorCategoria={gastosPorCategoria}
          ultimasTransacciones={ultimasTransacciones}
        />
      )}

      {activeTab === "historial" && <HistorialView />}
    </div>
  );
}
